import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import {
//   Box,
//   Stepper,
//   Step,
//   StepLabel,
//   useMediaQuery,
//   useTheme,
//   Typography,
// } from "@mui/material";
// import { between, centered } from "@ui/style/style";
// import * as React from "react";
// import { styled } from "@mui/material/styles";
// import StepConnector, {
//   stepConnectorClasses,
// } from "@mui/material/StepConnector";
// import { StepIconProps } from "@mui/material/StepIcon";
// interface SteperProps {
//   activeStep: number;
//   tabValue?: number;
//   eventType: string;
//   steps: { description: string; icon: React.ReactNode }[];
// }
// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 16,
//   },
//   [`&.${stepConnectorClasses.active}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundColor: "#E9E9E933",
//     },
//   },
//   [`&.${stepConnectorClasses.completed}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundColor: "#E9E9E933",
//     },
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     height: 3,
//     border: 0,
//     backgroundColor: "#E9E9E933",
//     ...theme.applyStyles("dark", {
//       backgroundColor: theme.palette.grey[800],
//     }),
//   },
// }));
// const CustomStepIcon = (props: StepIconProps) => {
//   const { active, completed, icon } = props;
//   return (
//     <Box
//       sx={{
//         ...centered,
//         width: 38,
//         height: 38,
//         borderRadius: "50%",
//         border: "1px solid",
//         borderColor: completed ? "#00B6ED" : active ? "#00B6ED" : "#FFFFFF99",
//         backgroundColor: completed
//           ? "#00B6ED"
//           : active
//             ? "#00B6ED"
//             : "transparent",
//         color: "#FFFFFF",
//         fontWeight: 500,
//         fontSize: 16,
//       }}
//     >
//       {icon}
//     </Box>
//   );
// };
// export const Steper = ({
//   activeStep,
//   eventType,
//   steps,
//   tabValue,
// }: SteperProps) => {
//   const theme = useTheme();
//   const isMd = useMediaQuery(theme.breakpoints.down("md"));
//   const isLg = useMediaQuery(theme.breakpoints.up("md"));
//   // Calculate the visible step index based on tabValue and current step
//   const getVisibleStepIndex = (index: number) => {
//     if (eventType === "family") {
//       if (Number(tabValue) === 1) {
//         // Coming alone
//         // Skip Adults(1) and Children(2) steps
//         if (index > 2) return index - 2;
//         return index;
//       } else if (Number(tabValue) === 2) {
//         // Coming with introduction
//         // Skip Children(2) step
//         if (index > 2) return index - 1;
//         return index;
//       }
//     }
//     return index;
//   };
//   // Filter out steps that should be hidden
//   const visibleSteps = steps.filter((_, index) => {
//     if (eventType === "directors" && index === 4) return false;
//     if (
//       eventType === "family" &&
//       Number(tabValue) === 1 &&
//       (index === 1 || index === 2)
//     )
//       return false;
//     if (eventType === "family" && Number(tabValue) === 2 && index === 2)
//       return false;
//     return true;
//   });
//   return (
//     <Box mb={isMd ? 1 : 2}>
//       <Stepper
//         activeStep={getVisibleStepIndex(activeStep - 1)}
//         orientation={"horizontal"}
//         alternativeLabel
//         sx={{ width: "100%" }}
//         connector={<ColorlibConnector />}
//       >
//         {visibleSteps.map((step, index) => (
//           <Step key={step.description}>
//             <StepLabel StepIconComponent={CustomStepIcon}>
//               {isMd ? (
//                 ""
//               ) : (
//                 <Typography variant="subtitle2" color="#FFFFFF">
//                   {step.description}
//                 </Typography>
//               )}
//             </StepLabel>
//           </Step>
//         ))}
//       </Stepper>
//       {isMd && activeStep < 6 && (
//         <Box sx={{ ...centered }} mt={"15px"} px={"10px"}>
//           <Typography variant="caption" color="#fff">
//             Step {getVisibleStepIndex(activeStep - 1) + 1} :
//           </Typography>
//           &nbsp;
//           <Typography variant="caption" color="#fff">
//             {visibleSteps[getVisibleStepIndex(activeStep - 1)]?.description}
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };
import { Box, Stepper, Step, StepLabel, useMediaQuery, useTheme, Typography, } from "@mui/material";
import { centered } from "@ui/style/style";
import { styled } from "@mui/material/styles";
import StepConnector, { stepConnectorClasses, } from "@mui/material/StepConnector";
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 16,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: "#E9E9E933",
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: "#E9E9E933",
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: "#E9E9E933",
        ...theme.applyStyles("dark", {
            backgroundColor: theme.palette.grey[800],
        }),
    },
}));
const CustomStepIcon = (props) => {
    const { active, completed, icon } = props;
    return (_jsx(Box, { sx: {
            ...centered,
            width: 32,
            height: 32,
            borderRadius: "50%",
            border: "1px solid",
            borderColor: completed ? "#00B6ED" : active ? "#00B6ED" : "#FFFFFF99",
            backgroundColor: completed
                ? "#00B6ED"
                : active
                    ? "#00B6ED"
                    : "transparent",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: 16,
            zIndex: 1,
        }, children: icon }));
};
export const Steper = ({ activeStep, eventType, steps, tabValue, }) => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("md"));
    // Filter out steps based on eventType and tabValue
    const visibleSteps = steps.filter((_, index) => {
        if (eventType === "directors" && index === 4)
            return false;
        if (eventType === "family" &&
            Number(tabValue) === 1 &&
            (index === 1 || index === 2))
            return false;
        if (eventType === "family" && Number(tabValue) === 2 && (index === 1 || index === 2))
            return false;
        return true;
    });
    // Match activeStep in original array to visible steps
    const getVisibleStepIndex = () => {
        const originalStepIndex = activeStep - 1;
        const visibleStepIndex = visibleSteps.findIndex((visibleStep) => steps.findIndex((s) => s.description === visibleStep.description) ===
            originalStepIndex);
        return visibleStepIndex;
    };
    return (_jsxs(Box, { mb: isMd ? 1 : 2, children: [_jsx(Stepper, { activeStep: getVisibleStepIndex(), orientation: "horizontal", alternativeLabel: true, sx: {
                    width: "100%",
                    '& .MuiStep-root': {
                        padding: 0,
                    },
                    '& .MuiStepConnector-root': {
                        padding: 0,
                        margin: 0,
                    },
                    '& .MuiStepConnector-line': {
                        minWidth: '100%',
                    },
                }, connector: _jsx(ColorlibConnector, {}), children: visibleSteps.map((step) => (_jsx(Step, { children: _jsx(StepLabel, { StepIconComponent: CustomStepIcon, children: !isMd && (_jsx(Typography, { variant: "subtitle2", color: "#FFFFFF", children: step.description })) }) }, step.description))) }), isMd && activeStep < 6 && (_jsx(Box, { sx: { ...centered }, mt: "15px", px: "10px" }))] }));
};
